<div class="content-body">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList"> </app-breadcrumb>
    
   <!-- row -->
  <div class="container-fluid">
      <div class="row">
          <div class="col-xl-9 wid-100">
              <div class="row">
                  <div class="col-xl-3 col-sm-6">
                      <div class="card chart-grd same-card">
                          <div class="card-body depostit-card">
                              <div class="depostit-card-media d-flex justify-content-between pb-0">
                                  <div>
                                      <h6>Total Properties</h6>
                                      <h3>1200</h3>
                                  </div>
                                  
                              </div>
                              <!-- <div id="NewCustomers">
                                <app-bar-chart-apex [chart_item]="NewCustomers"></app-bar-chart-apex>
                              </div> -->
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-3 col-sm-6">
                      <div class="card same-card">
                          <div class="card-body depostit-card">
                              <!-- <div id="AllProject"><app-bar-chart-apex [chart_item]="AllProject"></app-bar-chart-apex></div> -->
                              <div class="depostit-card-media d-flex justify-content-between pb-0">
                                  <div>
                                      <h6>Total Users</h6>
                                      <h3>1200</h3>
                                  </div>
                                  
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-3 col-sm-6">
                      <div class="card chart-grd same-card">
                          <div class="card-body depostit-card">
                              <div class="depostit-card-media d-flex justify-content-between pb-0">
                                  <div>
                                      <h6>Total Expenses</h6>
                                      <h3>$1200.00</h3>
                                  </div>
                                  <div class="icon-box bg-danger-light">
                                      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.4642 13.7074C11.4759 12.1252 10.8504 10.8738 9.60279 9.99009C8.6392 9.30968 7.46984 8.95476 6.33882 8.6137C3.98274 7.89943 3.29927 7.52321 3.29927 6.3965C3.29927 5.14147 4.93028 4.69493 6.32655 4.69493C7.34341 4.69493 8.51331 5.01109 9.23985 5.47964L10.6802 3.24887C9.73069 2.6333 8.43112 2.21342 7.14783 2.0831V0H4.49076V2.22918C2.12884 2.74876 0.640949 4.29246 0.640949 6.3965C0.640949 7.87005 1.25327 9.03865 2.45745 9.86289C3.37331 10.4921 4.49028 10.83 5.56927 11.1572C7.88027 11.8557 8.81873 12.2813 8.80805 13.691L8.80799 13.7014C8.80799 14.8845 7.24005 15.3051 5.89676 15.3051C4.62786 15.3051 3.248 14.749 2.46582 13.9222L0.535522 15.7481C1.52607 16.7957 2.96523 17.5364 4.4907 17.8267V20.0001H7.14783V17.8735C9.7724 17.4978 11.4616 15.9177 11.4642 13.7074Z"
                                          fill="#FF5E5E" />
                                      </svg>
                                  </div>
                              </div>
                              <!-- <div id="NewExperience"><app-bar-chart-apex [chart_item]="NewExperience"></app-bar-chart-apex></div> -->
                          </div>
                      </div>
                  </div>
                   <div class="col-xl-3 col-sm-6">
                      <div class="card chart-grd same-card">
                          <div class="card-body depostit-card">
                              <div class="depostit-card-media d-flex justify-content-between pb-0">
                                  <div>
                                      <h6>Total Income</h6>
                                      <h3>$1200.00</h3>
                                  </div>
                                  <div class="icon-box bg-danger-light">
                                      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M11.4642 13.7074C11.4759 12.1252 10.8504 10.8738 9.60279 9.99009C8.6392 9.30968 7.46984 8.95476 6.33882 8.6137C3.98274 7.89943 3.29927 7.52321 3.29927 6.3965C3.29927 5.14147 4.93028 4.69493 6.32655 4.69493C7.34341 4.69493 8.51331 5.01109 9.23985 5.47964L10.6802 3.24887C9.73069 2.6333 8.43112 2.21342 7.14783 2.0831V0H4.49076V2.22918C2.12884 2.74876 0.640949 4.29246 0.640949 6.3965C0.640949 7.87005 1.25327 9.03865 2.45745 9.86289C3.37331 10.4921 4.49028 10.83 5.56927 11.1572C7.88027 11.8557 8.81873 12.2813 8.80805 13.691L8.80799 13.7014C8.80799 14.8845 7.24005 15.3051 5.89676 15.3051C4.62786 15.3051 3.248 14.749 2.46582 13.9222L0.535522 15.7481C1.52607 16.7957 2.96523 17.5364 4.4907 17.8267V20.0001H7.14783V17.8735C9.7724 17.4978 11.4616 15.9177 11.4642 13.7074Z"
                                          fill="#FF5E5E" />
                                      </svg>
                                  </div>
                              </div>
                              <!-- <div id="NewExperience"><app-bar-chart-apex [chart_item]="NewExperience"></app-bar-chart-apex></div> -->
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-8">
                      <div class="card overflow-hidden">
                            <!-- Projects Overview -->
                            <!-- <app-projects-overview></app-projects-overview> -->
                      </div>
                  </div>
                  <div class="col-xl-4">
                      <div class="card overflow-hidden">
                          <div class="card-header border-0">
                              <h4 class="heading mb-0">My To Do Items</h4>
                              <div>
                                  <a href="javascript:void(0);" class="text-primary me-2">View All</a>
                                  <a href="javascript:void(0);" class="text-black"> + Add To Do</a>
                              </div>
                          </div>
                          <div class="card-body p-0">
                            <!-- <app-my-to-do-list [data]="to_do_list"></app-my-to-do-list> -->
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-3 t-earn">
              <div class="card">
                  <div class="card-header border-0 pb-0">
                      <h4 class="heading mb-0">Total Earning</h4>
                  </div>
                  <div class="card-body px-0 overflow-hidden">
                     <!-- <app-total-earning></app-total-earning> -->
                  </div>
              </div>
          </div>
          <div class="col-xl-6 active-p">
              <div class="card">
                  <div class="card-body p-0">
                      <div class="table-responsive active-projects shorting dataTables_wrapper ">
                          <div class="tbl-caption">
                              <h4 class="heading mb-0">Active Projects</h4>
                          </div>
                         <!-- <app-active-projects-list></app-active-projects-list> -->
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-6 col-md-6 flag">
              <div class="card overflow-hidden">
                  <div class="card-body pe-0">
                      <div class="row">
                          <div class="col-xl-8 active-map-main">
                                <!-- <app-active-users></app-active-users> -->
                          </div>
                          <div class="col-xl-4 active-country dz-scroll">
                              <div class="">
                                  <div class="country-list">
                                      <img src="assets/images/country/india.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">India</p>
                                              <p class="mb-0">50%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:60%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/canada.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">Canada</p>
                                              <p class="mb-0">30%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:30%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/russia.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">Russia</p>
                                              <p class="mb-0">20%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:20%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/uk.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">United Kingdom</p>
                                              <p class="mb-0">40%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:40%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/aus.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">Australia</p>
                                              <p class="mb-0">60%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:70%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/usa.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">United States</p>
                                              <p class="mb-0">20%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:80%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/pak.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">Pakistan</p>
                                              <p class="mb-0">20%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:20%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/germany.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">Germany</p>
                                              <p class="mb-0">80%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:80%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/uae.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">UAE</p>
                                              <p class="mb-0">30%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:30%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="country-list">
                                      <img src="assets/images/country/china.png" alt="">
                                      <div class="progress-box mt-0">
                                          <div class="d-flex justify-content-between">
                                              <p class="mb-0 c-name">China</p>
                                              <p class="mb-0">40%</p>
                                          </div>
                                          <div class="progress">
                                              <div class="progress-bar bg-primary" style="width:40%; height:5px; border-radius:4px;" role="progressbar"></div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-4 col-md-6 chat-map">
              <div class="card">
                  <div class="card-header border-0 mb-0">
                      <h4 class="heading mb-0">Chat</h4>
                      <div class="d-flex align-items-center cs-settiong">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8711 5.08237L13.4561 4.36231C13.1051 3.75303 12.3271 3.54284 11.717 3.89244V3.89244C11.4266 4.06352 11.08 4.11206 10.7538 4.02735C10.4275 3.94264 10.1484 3.73164 9.97788 3.44087C9.86819 3.25606 9.80925 3.04556 9.80702 2.83065V2.83065C9.81691 2.48611 9.68693 2.15223 9.44667 1.90507C9.20641 1.65792 8.87634 1.51853 8.53166 1.51868H7.69565C7.35796 1.51867 7.03419 1.65324 6.79599 1.89259C6.55778 2.13194 6.42477 2.45635 6.42639 2.79404V2.79404C6.41638 3.49124 5.84831 4.05117 5.15103 4.05109C4.93613 4.04886 4.72562 3.98992 4.54081 3.88023V3.88023C3.93069 3.53064 3.15273 3.74082 2.80168 4.3501L2.35622 5.08237C2.00559 5.69089 2.21292 6.46836 2.81999 6.8215V6.8215C3.21459 7.04932 3.45767 7.47035 3.45767 7.926C3.45767 8.38164 3.21459 8.80268 2.81999 9.0305V9.0305C2.21369 9.38125 2.00614 10.1568 2.35622 10.7635V10.7635L2.77727 11.4897C2.94175 11.7865 3.21772 12.0055 3.54411 12.0983C3.87051 12.191 4.22041 12.1499 4.5164 11.984V11.984C4.80737 11.8142 5.15411 11.7677 5.47955 11.8548C5.80498 11.9418 6.08214 12.1553 6.24943 12.4477C6.35912 12.6326 6.41806 12.8431 6.42029 13.058V13.058C6.42029 13.7623 6.99129 14.3333 7.69565 14.3333H8.53166C9.23364 14.3333 9.80366 13.766 9.80702 13.0641V13.0641C9.80538 12.7253 9.93923 12.4 10.1788 12.1604C10.4183 11.9209 10.7436 11.7871 11.0824 11.7887C11.2968 11.7944 11.5064 11.8531 11.6926 11.9596V11.9596C12.3011 12.3102 13.0786 12.1029 13.4317 11.4958V11.4958L13.8711 10.7635C14.0412 10.4716 14.0878 10.124 14.0008 9.79754C13.9137 9.47112 13.7002 9.19286 13.4073 9.0244V9.0244C13.1145 8.85593 12.9009 8.57768 12.8139 8.25125C12.7268 7.92483 12.7735 7.57717 12.9436 7.28527C13.0541 7.09218 13.2142 6.93209 13.4073 6.8215V6.8215C14.0107 6.46855 14.2176 5.69562 13.8711 5.08847V5.08847V5.08237Z"
                              stroke="#0D99FF" stroke-linecap="round" stroke-linejoin="round" />
                              <circle cx="8.1167" cy="7.92602" r="1.75744" stroke="#0D99FF" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <!-- <app-dropdown [dropdown]="chat_dropdown"></app-dropdown> -->
                      </div>
                  </div>
                  <div class="card-body pt-0">
                      <div class="chat-box-area style-1 dz-scroll" id="chartBox2">
                          <div class="media">
                              <div class="message-received w-auto">
                                  <div class="d-flex">
                                      <img src="assets/images/contacts/pic2.jpg" class="avatar rounded-circle" alt="">
                                      <div class="ms-1 text">
                                          <p class="mb-1">Good morning</p>
                                          <p class="mb-1">Can you arrange schedule for next meeting?</p>
                                          <span>12:45 PM</span>
                                      </div>
                                  </div>
                              </div>

                          </div>
                          <span class="text-center d-block mb-4">Today</span>
                          <div class="media justify-content-end align-items-end ms-auto">
                              <div class="message-sent w-auto">
                                  <p class="mb-1">Very Good morning</p>
                                  <p class="mb-1">Okay, I’ll arrange it soon. i noftify you when</p>
                                  <p class="mb-1">Very Good morning</p>
                                  <p>Okay, I’ll arrange it soon. i noftify you when it’s done
                                      <br> +91-235 2574 2566
                                      <br> kk Sharma
                                      <br> pan card eeer2063i</p>
                                  <span class="fs-12">9.30 AM</span>
                              </div>
                          </div>
                      </div>
                      <div class="message-send">
                          <div class="type-massage style-1">
                              <div class="input-group">
                                  <textarea rows="1" class="form-control" placeholder="Hello Hanuman..."></textarea>
                              </div>

                          </div>
                          <button type="button" class="btn btn-primary p-2">
                              Send
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.555 5.44976L6.73936 9.30612L2.39962 6.59178C1.77783 6.20276 1.90718 5.25829 2.61048 5.05262L12.9142 2.03518C13.5582 1.84642 14.155 2.44855 13.9637 3.09466L10.9154 13.3912C10.7066 14.0955 9.76747 14.2213 9.38214 13.5968L6.73734 9.3068" stroke="white"
                                  stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                          </button>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-xl-5 bst-seller">
              <div class="card">
                  <div class="card-header border-0">
                      <h4 class="heading mb-0">Best Selling Products</h4>
                      <div class="d-flex align-items-center cs-settiong">
                          <span>SORT BY:</span>
                          <!-- <app-dropdown [dropdown]="selling_roducts_dropdown"></app-dropdown> -->
                      </div>
                  </div>
                  <div class="card-body p-0">
                     <!-- <app-best-selling-list></app-best-selling-list> -->
                  </div>
              </div>
          </div>
          <div class="col-xl-3 col-md-6 up-shd">
              <div class="card">
                  <div class="card-header border-0 pb-1">
                      <h4 class="heading mb-0">Upcoming Schedules</h4>
                  </div>
                  <!-- <app-upcoming-colander></app-upcoming-colander> -->
              </div>
          </div>
          <div class="col-xl-3 col-md-6 up-shd">
              <div class="card">
                  <div class="card-header pb-0 border-0">
                      <h4 class="heading mb-0">Projects Status</h4>
                      <!-- <app-dropdown [dropdown]="selling_roducts_dropdown"></app-dropdown> -->
                  </div>
                  <div class="card-body">
                      <!-- <div id="projectChart" class="project-chart"><app-bar-chart-apex [chart_item]="projectChart"></app-bar-chart-apex></div> -->
                      <div class="project-date">
                          <div class="project-media">
                              <p class="mb-0">
                                  <svg class="me-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect y="0.5" width="12" height="12" rx="3" fill="var(--primary)" />
                                  </svg>
                                  Completed Projects
                              </p>
                              <span>125 Projects</span>
                          </div>
                          <div class="project-media">
                              <p class="mb-0">
                                  <svg class="me-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect y="0.5" width="12" height="12" rx="3" fill="#3AC977" />
                                  </svg>
                                  Progress Projects
                              </p>
                              <span>125 Projects</span>
                          </div>
                          <div class="project-media">
                              <p class="mb-0">
                                  <svg class="me-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect y="0.5" width="12" height="12" rx="3" fill="#FF5E5E" />
                                  </svg>
                                  Cancelled
                              </p>
                              <span>125 Projects</span>
                          </div>
                          <div class="project-media">
                              <p class="mb-0">
                                  <svg class="me-2" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect y="0.5" width="12" height="12" rx="3" fill="#FF9F00" />
                                  </svg>
                                  Yet to Start
                              </p>
                              <span>125 Projects</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- <div class="col-xl-9 bst-seller">
              <div class="card">
                  <div class="card-body p-0">
                     employees List -->
                      <!-- <app-employees-list [offset_limit]="5" [checkbox]="true"></app-employees-list>
                  </div>
              </div>
          </div> --> 
      </div>
  </div>
</div>